import { Link } from 'react-router'

import { ApiError, type Findings, type Run } from './api'
import { progressText, statusKind } from './format'

export function FindingsList({ findings, empty }: { findings: Findings; empty?: string }) {
  if (!findings.errors.length && !findings.warnings.length) {
    return empty ? <p className="callout ok">{empty}</p> : null
  }
  return (
    <ul className="findings">
      {findings.errors.map((f, i) => (
        <li key={`e${i}`} className="callout err">
          <strong>Blocking</strong> {f.message} <code>{f.code}</code>
        </li>
      ))}
      {findings.warnings.map((f, i) => (
        <li key={`w${i}`} className="callout warn">
          <strong>Warning</strong> {f.message} <code>{f.code}</code>
        </li>
      ))}
    </ul>
  )
}

export function Pill({ kind, children }: { kind: 'ok' | 'warn' | 'err' | 'info' | 'neutral'; children: React.ReactNode }) {
  return <span className={`pill pill-${kind}`}>{children}</span>
}

/** Status pill plus live progress for a run, linking to its detail page. */
export function RunStatus({ run, link = true }: { run: Run; link?: boolean }) {
  const pill = <Pill kind={statusKind(run.status)}>{run.cancel_requested && run.status === 'running' ? 'cancelling' : run.status}</Pill>
  return (
    <span className="run-status">
      {link ? <Link to={`/runs/${run.id}`}>{pill}</Link> : pill}
      {run.status === 'running' && run.progress && <span className="muted mono">{progressText(run.progress)}</span>}
    </span>
  )
}

/** An API error with its rule findings, if any. */
export function ErrorBox({ error }: { error: Error }) {
  return (
    <div className="callout err">
      {error.message}
      {error instanceof ApiError && error.findings && <FindingsList findings={error.findings} />}
    </div>
  )
}
